(function (w) {
    'use strict';

    var cachedContentComponents = null;
    var cachedContentComponentsUrl = '';

    function sanitizeImageClassForStorage(cls) {
        if (!cls) {
            return '';
        }
        return cls.split(/\s+/).filter(function (c) {
            return !!c;
        }).join(' ');
    }

    function escapeHtml(value) {
        return (value || '').replace(/"/g, '&quot;');
    }

    function escapeJsSingleQuoted(value) {
        return String(value || '').replace(/\\/g, '\\\\').replace(/'/g, '\\\'');
    }

    function normalizeContentComponentsOption(raw) {
        if (!raw) {
            return { enabled: false, url: '/Admin/GetActiveContentComponents' };
        }
        if (raw === true) {
            return { enabled: true, url: '/Admin/GetActiveContentComponents' };
        }
        return {
            enabled: !!raw.enabled,
            url: raw.url || '/Admin/GetActiveContentComponents'
        };
    }

    function applyLegacyAttributesBySignature(workingHost, snapshotHost) {
        if (!workingHost || !snapshotHost) {
            return;
        }

        var sourceNodes = snapshotHost.querySelectorAll('a, img, iframe, div, span, p, h1, h2, h3, h4, h5, h6, li, ol, ul');
        var sourceMap = {};
        for (var i = 0; i < sourceNodes.length; i++) {
            var source = sourceNodes[i];
            var key = source.tagName + '|' + (source.getAttribute('src') || source.getAttribute('href') || '') + '|' + ((source.textContent || '').trim().slice(0, 120));
            if (!sourceMap[key]) {
                sourceMap[key] = source;
            }
        }

        var targetNodes = workingHost.querySelectorAll('a, img, iframe, div, span, p, h1, h2, h3, h4, h5, h6, li, ol, ul');
        for (var t = 0; t < targetNodes.length; t++) {
            var target = targetNodes[t];
            var targetKey = target.tagName + '|' + (target.getAttribute('src') || target.getAttribute('href') || '') + '|' + ((target.textContent || '').trim().slice(0, 120));
            var matched = sourceMap[targetKey];
            if (!matched || !matched.attributes) {
                continue;
            }
            for (var a = 0; a < matched.attributes.length; a++) {
                var attr = matched.attributes[a];
                if (attr.name === 'class') {
                    target.setAttribute('class', sanitizeImageClassForStorage(attr.value));
                } else if (attr.name === 'style' || attr.name === 'id' || attr.name.indexOf('data-') === 0 || attr.name.indexOf('aria-') === 0 || attr.name === 'target' || attr.name === 'rel' || attr.name === 'title' || attr.name === 'frameborder' || attr.name === 'allowfullscreen') {
                    target.setAttribute(attr.name, attr.value);
                }
            }
        }
    }

    function makeEditorApi(jodit, textarea) {
        var editableRoot = jodit.editor;
        if (!editableRoot && jodit.container) {
            editableRoot = jodit.container.querySelector('.jodit-wysiwyg');
        }
        return {
            jodit: jodit,
            root: editableRoot || jodit.container,
            textarea: textarea,
            onChange: function (callback) {
                if (typeof callback !== 'function') {
                    return;
                }
                jodit.events.on('change', callback);
            }
        };
    }

    function appendContentComponentsButton(buttons) {
        var next = buttons.filter(function (b) {
            return b !== 'plContentComponents';
        });

        var sourceIx = next.indexOf('source');
        if (sourceIx >= 0) {
            next.splice(sourceIx + 1, 0, 'plContentComponents');
            return next;
        }

        next.unshift('plContentComponents');
        return next;
    }

    function loadActiveContentComponents(url, onDone, onErr) {
        if (cachedContentComponents && cachedContentComponentsUrl === url) {
            onDone(cachedContentComponents);
            return;
        }
        if (typeof puritanLawn === 'undefined' || typeof puritanLawn.ajaxGet !== 'function') {
            onErr(new Error('puritanLawn.ajaxGet is not available.'));
            return;
        }
        puritanLawn.ajaxGet(url, function (data) {
            cachedContentComponents = Array.isArray(data) ? data : [];
            cachedContentComponentsUrl = url;
            onDone(cachedContentComponents);
        }, function () {
            onErr(new Error('Unable to load content components.'));
        });
    }

    function destroyPicker(root) {
        if (root && root.parentNode) {
            root.parentNode.removeChild(root);
        }
    }

    function openContentComponentsPicker(jodit, editorApi, ccOpts, selfSync) {
        loadActiveContentComponents(ccOpts.url, function (list) {
            if (!list.length) {
                window.alert('No active content components are defined.');
                return;
            }

            var doc = document;
            var overlay = doc.createElement('div');
            overlay.className = 'pl-jodit-cc-overlay';
            overlay.setAttribute('role', 'dialog');
            overlay.style.cssText = 'position:fixed;left:0;top:0;right:0;bottom:0;background:rgba(0,0,0,.35);z-index:2147483646;display:flex;align-items:flex-start;justify-content:center;padding:24px;box-sizing:border-box;overflow:auto;';

            var panel = doc.createElement('div');
            panel.style.cssText = 'background:#fff;color:#222;max-height:70vh;overflow:auto;border-radius:4px;box-shadow:0 4px 24px rgba(0,0,0,.25);max-width:440px;width:100%;padding:12px;margin-top:48px;';

            var title = doc.createElement('div');
            title.style.cssText = 'font-weight:600;margin-bottom:8px;font-size:16px;';
            title.textContent = 'Insert content component';
            panel.appendChild(title);

            function closeAll() {
                destroyPicker(overlay);
            }

            for (var i = 0; i < list.length; i++) {
                (function (item) {
                    var row = doc.createElement('button');
                    row.type = 'button';
                    row.style.cssText = 'display:block;width:100%;text-align:left;margin:6px 0;padding:10px;border:1px solid #dee2e6;background:#fafafa;cursor:pointer;border-radius:4px;font:inherit;';
                    var strong = doc.createElement('div');
                    strong.style.fontWeight = '600';
                    strong.textContent = item.name || ('#' + item.id);
                    row.appendChild(strong);
                    if (item.description) {
                        var small = doc.createElement('div');
                        small.style.cssText = 'font-size:12px;opacity:.85;margin-top:4px;';
                        small.textContent = item.description;
                        row.appendChild(small);
                    }
                    row.onclick = function () {
                        closeAll();
                        w.puritanLawnJodit.insertContentComponent(editorApi, item, ccOpts);
                        selfSync(editorApi);
                    };
                    panel.appendChild(row);
                })(list[i]);
            }

            var footer = doc.createElement('div');
            footer.style.cssText = 'margin-top:12px;text-align:right;';
            var cancel = doc.createElement('button');
            cancel.type = 'button';
            cancel.style.cssText = 'padding:6px 14px;border:1px solid #ccc;background:#fff;cursor:pointer;border-radius:4px;font:inherit;';
            cancel.textContent = 'Cancel';
            cancel.onclick = closeAll;
            footer.appendChild(cancel);
            panel.appendChild(footer);

            overlay.appendChild(panel);
            overlay.onclick = function (e) {
                if (e.target === overlay) {
                    closeAll();
                }
            };

            doc.body.appendChild(overlay);
        }, function () {
            window.alert('Unable to load content components. Try again or refresh the page.');
        });
    }

    function uploadDynamicContent(file, onSuccess, onError) {
        if (!file || typeof puritanLawn === 'undefined') {
            onError(new Error('Missing file or puritanLawn.'));
            return;
        }
        var formData = new FormData();
        formData.append('Files', file);
        var ft = (file.type === 'video/mp4')
            ? puritanLawn.fileType.DynamicContentVideo
            : puritanLawn.fileType.DynamicContentImage;
        formData.append('fileType', ft);

        puritanLawn.ajaxPostMultiPartFormData(
            puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            function (results) {
                if (!results || !results.length || !results[0].url) {
                    onError(new Error('Upload did not return a URL.'));
                    return;
                }
                onSuccess(results[0].url);
            },
            function () {
                onError(new Error('Upload failed.'));
            }
        );
    }

    function uploadParkSectionImage(file, onSuccess, onError) {
        var formData = new FormData();
        formData.append('Files', file);
        formData.append('fileType', puritanLawn.fileType.ParkSectionImage);

        puritanLawn.ajaxPostMultiPartFormData(
            puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            function (results) {
                if (!results || !results.length || !results[0].url) {
                    onError(new Error('Upload did not return a URL.'));
                    return;
                }
                onSuccess(results[0].url);
            },
            function () {
                onError(new Error('Upload failed.'));
            }
        );
    }

    function pickFile(accept, onFile) {
        var inp = document.getElementById('__plCcMediaFile');
        if (!inp) {
            inp = document.createElement('input');
            inp.type = 'file';
            inp.id = '__plCcMediaFile';
            inp.style.display = 'none';
            document.body.appendChild(inp);
        }
        inp.accept = accept || 'image/*,video/mp4';
        inp.value = '';
        inp.onchange = function () {
            var f = inp.files && inp.files[0];
            inp.value = '';
            if (f) {
                onFile(f);
            }
        };
        inp.click();
    }

    function moveCursorAfterLastInsertedNode(jodit) {
        if (!jodit || !jodit.s) {
            return;
        }

        var selection = jodit.s.sel;
        if (!selection || !selection.rangeCount) {
            return;
        }

        var range = selection.getRangeAt(0).cloneRange();
        var endNode = range.endContainer;

        // If caret lands in text, step to the parent element.
        if (endNode && endNode.nodeType === Node.TEXT_NODE) {
            endNode = endNode.parentNode;
        }
        if (!endNode || !endNode.parentNode) {
            return;
        }

        // Place caret immediately after inserted element/content.
        range.setStartAfter(endNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }

    w.puritanLawnJodit = {
        sync: function (editorApi, textarea) {
            var targetTextarea = textarea || (editorApi && editorApi.textarea);
            if (!editorApi || !targetTextarea) {
                return;
            }
            if (!editorApi.jodit) {
                targetTextarea.value = targetTextarea.value || '';
                return;
            }
            var html = editorApi.jodit.value || '';
            if (editorApi.jodit.__pl_snapshotHtml) {
                var currentHost = document.createElement('div');
                currentHost.innerHTML = html;
                var snapshotHost = document.createElement('div');
                snapshotHost.innerHTML = editorApi.jodit.__pl_snapshotHtml;
                applyLegacyAttributesBySignature(currentHost, snapshotHost);
                html = currentHost.innerHTML;
            }
            targetTextarea.value = html;
        },

        bindFormSubmit: function (editorApi, textarea, formSelector) {
            var self = this;
            $(formSelector).on('submit', function () {
                self.sync(editorApi, textarea);
            });
        },

        insertContentComponent: function (editorApi, row, ccOpts) {
            ccOpts = ccOpts || {};
            if (!editorApi || !editorApi.jodit || !row) {
                return;
            }
            var template = row.template || '';
            var colon = template.indexOf(':');
            if (colon < 0) {
                window.alert('Invalid component template (missing prefix).');
                return;
            }
            var kind = template.substring(0, colon).trim().toLowerCase();
            var payload = template.substring(colon + 1);
            var j = editorApi.jodit;
            var self = this;

            if (kind === 'insert') {
                j.s.insertHTML(payload);
                moveCursorAfterLastInsertedNode(j);
                self.sync(editorApi);
                return;
            }

            if (kind === 'imagepopup' || kind === 'videopopup') {
                var accept = (kind === 'videopopup') ? 'video/mp4,image/*' : 'image/*';
                pickFile(accept, function (file) {
                    uploadDynamicContent(file, function (url) {
                        var html = payload.split('{url}').join(escapeJsSingleQuoted(url));
                        j.s.insertHTML(html);
                        moveCursorAfterLastInsertedNode(j);
                        self.sync(editorApi);
                    }, function (err) {
                        window.alert(err.message || 'Upload failed.');
                    });
                });
                return;
            }

            if (kind === 'imageswap') {
                var swapId = (payload || '').trim();
                if (!swapId) {
                    window.alert('Invalid image swap id.');
                    return;
                }
                var imgHtml = '<img id="' + escapeHtml(swapId) + '" src="/images/nopic.jpg" alt="" />';
                j.s.insertHTML(imgHtml);
                moveCursorAfterLastInsertedNode(j);
                pickFile('image/*', function (file) {
                    uploadParkSectionImage(file, function (url) {
                        var el = document.getElementById(swapId);
                        if (el) {
                            el.setAttribute('src', url);
                        }
                        window.alert('Image swapped successfully!  Please note, the affected image may not be visible in the editor due to the structure of the underlying HTML.');
                        self.sync(editorApi);
                    }, function (err) {
                        window.alert(err.message || 'Upload failed.');
                    });
                });
                return;
            }

            window.alert('Unknown template type: ' + kind);
        },

        create: function (editorSelector, textareaSelector, options) {
            options = options || {};

            var textarea = document.querySelector(textareaSelector);
            var initialHtml = options.initialHtml || (textarea ? textarea.value : '') || '';

            if (typeof Jodit === 'undefined') {
                throw new Error('Jodit is not loaded.');
            }

            var editorHost = typeof editorSelector === 'string'
                ? document.querySelector(editorSelector)
                : editorSelector;
            if (!editorHost) {
                throw new Error('Editor element not found: ' + editorSelector);
            }

            var configuredButtons = options.buttons || [
                'source', '|',
                'paragraph', 'font', 'fontsize', '|',
                'bold', 'italic', 'underline', 'strikethrough', '|',
                'brush', 'superscript', 'subscript', '|',
                'ul', 'ol', '|',
                'outdent', 'indent', '|',
                'left', 'center', 'right', 'justify', '|',
                'table', 'link', 'kygImageUpload', 'video', '|',
                'undo', 'redo', '|',
                'hr', 'eraser', 'fullsize'
            ];

            var ccOpts = normalizeContentComponentsOption(options.contentComponents);
            if (ccOpts.enabled) {
                configuredButtons = appendContentComponentsButton(configuredButtons);
            }

            var editorApiSlot = { api: null };

            var controls = {
                kygImageUpload: {
                    icon: 'image',
                    tooltip: 'Insert image',
                    exec: function () {
                        if (options && typeof options.imageHandler === 'function') {
                            options.imageHandler();
                        }
                        return false;
                    }
                }
            };

            var self = this;
            if (ccOpts.enabled) {
                controls.plContentComponents = {
                    icon: 'add',
                    text: 'Puritan Lawn Components',
                    tooltip: 'Puritan Lawn Components',
                    exec: function () {
                        openContentComponentsPicker(null, editorApiSlot.api, ccOpts, function (ea) {
                            self.sync(ea);
                        });
                        return false;
                    }
                };
            }

            var editorHeight = typeof options.height === 'number' ? options.height : 580;

            var jodit = new Jodit(editorHost, {
                toolbarAdaptive: false,
                showCharsCounter: false,
                showWordsCounter: false,
                showXPathInStatusbar: true,
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
                defaultActionOnPaste: 'insert_as_html',
                height: editorHeight,
                cleanHTML: {
                    removeEmptyElements: false,
                    fillEmptyParagraph: false
                },
                controls: controls,
                buttons: configuredButtons
            });

            jodit.value = initialHtml;
            jodit.__pl_snapshotHtml = initialHtml;

            var editorApi = makeEditorApi(jodit, textarea);
            editorApiSlot.api = editorApi;

            jodit.events.on('change', function () {
                self.sync(editorApi, textarea);
            });

            if (options.formSelector) {
                this.bindFormSubmit(editorApi, textarea, options.formSelector);
            }
            this.sync(editorApi, textarea);

            return editorApi;
        },

        insertImageUrl: function (editorApi, url) {
            if (!editorApi || !url || !editorApi.jodit) {
                return;
            }
            editorApi.jodit.s.insertHTML('<img src="' + escapeHtml(url) + '" alt="" />');
            this.sync(editorApi);
        }
    };
})(window);
